import $ from 'jquery';
import Floorplan from './Floorplan';

export default class Explorer {
  constructor (explorer) {
    if (!explorer) return false;

    this.el = explorer
    this.form = this.el.querySelector('.js-explorer-form')
    this.output = this.el.querySelector('.js-explorer-output')
    if (!this.form || !this.output){
        return false;
    }
    
    // this.floorRange = this.form.querySelector('#inputFloor');
    // this.bedroomRange = this.form.querySelector('#inputBedroom');
    this.floorRange = this.form.querySelector('.js-explorer-floor');
    this.bedroomRange = this.form.querySelector('.js-explorer-bedroom');
    this.floorLabel = this.form.querySelector(`label[for=${this.floorRange.id}]`);
    this.bedroomLabel = this.form.querySelector(`label[for=${this.bedroomRange.id}]`);

    this.setFilterLabels();
    this.listen();

    this.initFloorPlan()
  }

  listen() {
    // Update value from input to label on drag (no change event fired)
    this.floorRange.oninput = () => {
      this.setFilterLabels()
    }

    this.bedroomRange.oninput = () => {
      this.setFilterLabels();
    }

    // When released drag, request is fired
    this.floorRange.onchange = () => {
      this.submitRequest();
      // this.setFilterLabels()
    }

    this.bedroomRange.onchange = () => {
      this.submitRequest();
      // this.setFilterLabels()
    }
  }

  httpSend() {
    this.disableInput();

    return $.ajax({
      type: 'GET',
      url: this.form.action + 'floorplan',
      data: {
        floor: this.floorRange.value,
        bedrooms: this.bedroomRange.value,
      }
    })
  }

  initFloorPlan() {
    this.floorplan = this.el.querySelector('.js-explorer-floorplan')
    if(this.floorplan !== null){
        new Floorplan(this.floorplan)
    }
  }

  submitRequest() {
    var ajax = this.httpSend();

    ajax.done(res => {
      this.enableInput();
      this.output.innerHTML = res;

      this.initFloorPlan()
    });
  }

  disableInput() {
    this.floorRange.setAttribute('disabled', true);
    this.bedroomRange.setAttribute('disabled', true);
  }

  enableInput() {
    this.floorRange.removeAttribute('disabled');
    this.bedroomRange.removeAttribute('disabled');
  }

  setFilterLabels() {
    this.floorLabel.innerText = this.getReadableFloor($(this.floorRange).val());
    this.bedroomLabel.innerText = this.getReadableBedroom($(this.bedroomRange).val());
  }

  getReadableFloor($floor) {
    if ($floor <= 0) return 'B';
    else if ($floor == 1)  return 'G';
    else return $floor - 1;
  }

  getReadableBedroom($bedroom) {
    if ($bedroom == 0) return 'All';
    return $bedroom;
  }

}
